import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { IconButton } from 'react-toolbox/lib/button';
import { Dialog } from 'react-toolbox';
import ColoredButton from 'components/ColoredButton';
import RadioButtons from 'components/RadioButtons';
import StyledSelect from 'components/StyledSelect';
import TextArea from 'components/TextArea';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import modalStyles from 'modal.scss';
import { deriveStatusName } from '../../../../../../../../../utils';
import S from 'components/ComposeWindow/styles.scss';

const BUTTONS = [{ label: 'YES', value: 'yes' }, { label: 'NO', value: 'no' }];

export default class LeadAssessmentModal extends Resetter(Validator(React.Component)) {
  constructor(props) {
    super(props);
    const { phase: { year_built } } = this.props;
    this.state = {
      disruptingLead: this.noAssessmentRequired(year_built) ? 'no' : '',
      note: '',
      status: null,
    };
  }

  noAssessmentRequired = year_built => year_built >= 1978;

  handleSubmit = () => {
    const { disruptingLead, status, note } = this.state;
    const { phase: { id }, task: { slug }, updatePhaseTask } = this.props;
    updatePhaseTask(id, slug, {
      task: { status: 'complete' },
      data: { disrupting_lead: disruptingLead, comm_note: note },
    }).then(() => this.handleClose()).catch(() => {});
    if (status) {
      const phaseProps = { phase: { status }, event: { data: { note: '' } } };
      this.props.overridePhaseStatus(id, phaseProps, { source: 'lead assessment', delete_appointments: 'no' });
    }
  }

  handleDisruptingLead = value => this.setState({ disruptingLead: value });

  handleStatus = value => this.setState({ status: value });

  handleNoteChange = e => this.setState({ note: e.target.value });

  missingFieldsMessage = (disruptingLead, note) => {
    const fieldArr = [];
    if (!disruptingLead) fieldArr.push('Answer Needed');
    if (!note) fieldArr.push('Note Needed');
    return fieldArr.join(', ');
  }

  render = () => {
    const { active, task, phase: {
      status: phaseStatus, available_statuses,
      year_built, source, workroom: { name: workroom },
    } } = this.props;
    const { disruptingLead, status, note } = this.state;
    const blockedStatuses = ['completed', 'canceled', phaseStatus];
    const statuses = available_statuses.map(s =>
      ({ ...s, label: deriveStatusName(s.label, { source, workroom }) }))
      .filter(s => !blockedStatuses.includes(s.value));
    const disabled = (!note || !disruptingLead);
    return (<Dialog
      active={active}
      className={modalStyles.modal}
      type="fullscreen"
      onEscKeyDown={this.handleClose}
      onOverlayClick={this.handleClose}
    >
      <IconButton
        icon="close"
        className={modalStyles.close}
        onClick={this.handleClose}
        tabIndex={-1}
      />
      <h5 className={modalStyles.title}>Complete Task: {task.name}</h5>
      {this.noAssessmentRequired(year_built) ? (<Fragment>
        <div>
          Structure was built after 1977, no lead inspection required
        </div>
        <br />
      </Fragment>) : (<RadioButtons
        onChange={this.handleDisruptingLead}
        selectedValue={disruptingLead}
        radioButtons={BUTTONS}
        text="During inspection, was it determined that we would disrupt more than 6 sqft. of potential lead?"
      />)}
      <StyledSelect
        className={S.select}
        label="Override to Status"
        onChange={this.handleStatus}
        options={statuses}
        value={status}
        placeholder={'Select'}
      />
      <TextArea
        label="Notes *"
        value={note}
        onChange={this.handleNoteChange}
        autoFocus
      />
      <div className={modalStyles.actions}>
        {disabled && <p className={modalStyles.missingFieldsMessage}>
          {this.missingFieldsMessage(disruptingLead, note)}</p>}
        <ColoredButton
          color="green"
          responsive
          label="Complete Task"
          className={modalStyles.button}
          onClick={this.handleSubmit}
          disabled={disabled}
        />
        <ColoredButton
          color="darkGray"
          responsive
          label="Cancel"
          className={modalStyles.button}
          onClick={this.handleClose}
        />
      </div>
    </Dialog>);
  }
}

LeadAssessmentModal.propTypes = {
  active: PropTypes.bool.isRequired,
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  onClose: PropTypes.func.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  overridePhaseStatus: PropTypes.func.isRequired,
};

LeadAssessmentModal.defaultProps = { active: false };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/LeadAssessmentModal/index.jsx